<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        24.5.2024
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Sexualität im Alter – Podium Adullam Basel am 11.06.2024</h3>
      <div class="mb-1 text-body-secondary">24.5.2024</div>
      <p>
        Isabelle Kölbl: <q>Es wäre eigentlich alles sehr einfach... wenn natürlicher mit der Sexualität umgegangen wird, wenn sie ihre Berechtigung und ihren Raum erhält, dann wird sie zur friedvollen, wunderbaren und zärtlichsten Sprache der Welt...Sexualität wird zu einer erweiterten Form der Kommunikation.
        Alles was es dazu braucht sind sensibilisierte, geschulte Menschen.</q>
      </p>
      <p>
        Danke für die Einladung, ich freue mich auf eine spannende Diskussionsrunde mit:
      </p>
      <ul>
        <li><span class="fw-bold">PD Dr. med. Thomas Münzer,</span> Geriatrische Klinik St. Gallen</li>
        <li><span class="fw-bold">Stephan Dinkler,</span> Pflegeexperte Adullam Spitäler und Pflegezentren</li>
        <li><span class="fw-bold">Isabelle Kölbl,</span> Sexualbegleiterin und Begründerin von Sexcare</li>
        <li><span class="fw-bold">Marcello Schumacher,</span> Co-Präsident Queer Altern Region Basel</li>
      </ul>
      <p>Moderation: <span class="fw-bold"> Regula Zehnder,</span> Radioredaktorin Gesundheit/Medizin, SRF</p>

      <p>
        <a href="/../../../content/docs/Sexualität-im-Alter-Adullam-Podium-Basel.pdf" target="_blank">
          Flyer
        </a>
      </p>
    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog18_1.png" alt="sexcare bild" width="250">
    </div>
  </div>
</div>
